import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { useEffect, useRef, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NavigationContext from 'wfui-digital-core/es/NavigationContext';
import globals from '../../lib/globals/globals';
import logger from '../../lib/logger/logger';
import NavigationItemRecord from '../../lib/records/NavigationItemRecord';
import { requestNavigation } from '../../lib/store/navigation/actions';

var findAllByKey = function findAllByKey(obj, keyToFind) {
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return key === keyToFind ? acc.concat(value) : _typeof(value) === 'object' ? acc.concat(findAllByKey(value, keyToFind)) : acc;
  }, []);
};

var getBiometricLink = function getBiometricLink(obj) {
  return findAllByKey(obj, 'links').filter(function (link) {
    return link.navigationId === 'BIOMETRIC_SIGN_ON';
  }).map(function (link) {
    return new NavigationItemRecord({
      linkId: link.navigationId,
      displayType: link.type,
      navigationUrl: link.url
    });
  })[0];
};

var BiometricsEnroll = function BiometricsEnroll() {
  var navigated = useRef(false);
  var dispatch = useDispatch();

  var _ref3 = useContext(NavigationContext) || {},
      getContainer = _ref3.getContainer;

  var biometricNavigation = useSelector(function (_ref4) {
    var core = _ref4.core;
    return core.navigationMenu.navigationItems.get('BIOMETRIC_SIGN_ON');
  });

  if (globals().useMobileStickyFooter && !biometricNavigation) {
    var container = getContainer('NAVBAR');

    if (container) {
      biometricNavigation = getBiometricLink(container);
    }
  } // When the server populates mwfGlobals.biometricEnrollUrl, we trigger
  // a navigation to the url defined by BIOMETRIC_SIGN_ON, and we indicate
  // that the user selected "Set up Biometric" on the native sign-in
  // screen (fp = 'front porch').


  useEffect(function () {
    var _globals = globals(),
        navigationUrl = _globals.biometricEnrollUrl;

    if (!navigated.current && biometricNavigation && navigationUrl) {
      logger.debug('Biometrics: Enroll');
      var navigationItem = Object.assign({}, biometricNavigation.toJS(), {
        navigationUrl: navigationUrl,
        accessPoint: 'fp'
      });
      navigated.current = true;
      dispatch(requestNavigation(new NavigationItemRecord(navigationItem)));
    }
  }, [biometricNavigation, dispatch]);
  return null;
};

export default BiometricsEnroll;